import { Controller } from "stimulus"

export default class extends Controller {
  static values = { organizationId: Number }

  toggle(event) {
    const checkbox = event.target
    const applicationId = checkbox.dataset.applicationId
    const checked = checkbox.checked

    fetch(`/admin/organizations/${this.organizationIdValue}/toggle_application`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name=csrf-token]").content
      },
      body: JSON.stringify({
        application_id: applicationId,
        included: checked
      })
    })
  }
}
